import { Component, OnDestroy, OnInit } from "@angular/core";
import { isODM } from "../../../../environments/environment";
import { Confirm_button } from "../../../../environments/environment";
import { MessageService, TreeNode, SortEvent } from "primeng/api";
import { SelectItem, ToastMessageOptions as Message } from "primeng/api";
import { combineLatest, Observable, Subject } from "rxjs";
import * as fromStore from "../../../store";
import {
  DeviceMgtList,
  DeviceSettingList,
  DeviceSettingFilter,
} from "../../../my-features/device-mgt/device-mgt.model";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Store, select } from "@ngrx/store";
import { map, takeUntil } from "rxjs/operators";
import * as fromFeature from "../../../my-features";
import { Router } from '@angular/router';
import { AccountMgtListFilter } from '../../../my-features/account/account.model';
import { UserActivityLogParam } from '../../../my-features/user-activity-log/user-activity-log.model';

@Component({
  standalone: false,
  selector: "app-api-mgt-list",
  templateUrl: "./api-mgt-list.component.html",
  styleUrls: ["./api-mgt-list.component.css"],
})
export class ApiMgtListComponent implements OnInit, OnDestroy {

  deviceSettingData_cols: any[] = [
    { field: 'RegionName', header: 'Company', width: '200', class: 'col-nowrap', disabled: false },
    // { field: 'apiKeyId', header: 'ID', width: '150', class: 'col-nowrap', disabled: false },
    { field: 'name', header: 'Name', width: '220', class: 'col-nowrap', disabled: false },
    { field: 'apiKey', header: 'API Key', width: '350', class: 'col-nowrap', disabled: false },
    { field: 'Account', header: 'Account', width: '250', class: 'col-nowrap', disabled: false },
    { field: 'CreateTime', header: 'Create Date', width: '150', class: 'col-nowrap', disabled: false },
    { field: 'ExpiredDate', header: 'Expired Date', width: '150', class: 'col-nowrap', disabled: false },
    { field: 'status', header: 'Status', width: '100', class: 'col-nowrap', disabled: false },
  ];
  // CompanyOptions$: Observable<any>;
  CompanyOptions = [];
  monthlyAPICallsData = [];
  monthlyAPICallsAllTimeData = [];
  chart7: any;
  total_cols: any[] = [];
  totalAllTime_cols: any[] = [];
  frozenCols: any[];
  private readonly typeColumn = { field: 'type', header: 'Type', class: 'type', width: '230' };
  chartArr: string[] = [];
  chartOption: any;
  FilterParam: DeviceSettingFilter = { RegionId: -1 };
  filterParams: AccountMgtListFilter = {
    RegionId: 1,
    Authority: -1
  };
  logparam: UserActivityLogParam = {
    type: [0, 1, 2, 3, 4, 6],
    start_date: 0,
    end_date: 0,
    region: null,
    is_AllTime: false
  };
  apiSettingData: any;
  apiList: any;
  isSuperAdmin= false;
  private componentDestroyed = new Subject();
  constructor(private ngxService: NgxUiLoaderService, 
    private store: Store<fromStore.State>, 
    private messageService: MessageService, 
    private router: Router,) {

    this.store.dispatch(new fromFeature.GetApiKeys());

    // Get User Info
    this.store.pipe(select(fromStore.getCurrentUser)).subscribe(res => {
      this.isSuperAdmin = res.authority && res.authority === 2 ? true : false;
      if (!this.isSuperAdmin && window.location.pathname === '/management/api') {
        this.router.navigate(['/index']);
      };
      
      if (this.isSuperAdmin) {
        this.filterParams = {
          ...this.filterParams,
          RegionId: -1, // All Regions
        };
      } else {
        this.filterParams = {
          ...this.filterParams,
          RegionId: res.RegionId,
        };
      }
    });

    this.store.select(fromStore.getApiKey).subscribe((result) => {
      if (result !== undefined && result.length > 0) {
        this.apiSettingData = [];
        this.apiList = [];
        this.CompanyOptions = []
        this.apiSettingData = result;
        this.apiList = result;
        result.map((r) => {
          if (this.CompanyOptions.length > 0) {
            const companyItem = this.CompanyOptions.find(c => c.value === r.RegionId);
            if (companyItem === undefined) {
              this.CompanyOptions.push({ label: r.RegionName, value: r.RegionId })
            }
          } else {
            this.CompanyOptions.push({ label: r.RegionName, value: r.RegionId })
          }
        })
      }
    });
    
    this.store.select(fromStore.GetUserActivityReportData).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      this.monthlyAPICallsData = res.monthlyAPICallsData;
      this.total_cols = this.prependTypeColumn(res.total_cols);
      this.chart7 = res.APIChart;
    });

    this.chartOption = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'bottom',
          // reverse: true,
          // display: false
        },
        datalabels: {
          display: false,
        },
      },
      scales: {
        leftyAxisID: {
          type: 'linear',
          position: 'left',
          ticks: {
            min: 0,
            padding: 10,
            color: '#666666',
          },
          grid: {
            drawTicks: false,
            color: '#f0f0f0'
          },
          title: {
            display: true,
          },
          beginAtZero: true,
        },
        rightyAxisID: {
          type: 'linear',
          position: 'right',
          grid: {
            display: false
          },
          title: {
            display: true,
            text: 'MoM%',
          },
          beginAtZero: true,
        }
      },
      elements: {
        // line: {
        //   tension: 0
        // }
      }
    };
  }

  ngOnInit() {
    this.UI();
    this.GetDefaultDate()
    this.frozenCols = [
      { field: 'type', header: 'Type', class: 'type', }
    ];
    this.logparam = {
      ...this.logparam,
      region: (this.filterParams.RegionId === -1) ? null : this.filterParams.RegionId,
      is_AllTime: false,
    };
    this.store.dispatch(new fromFeature.GetPlanMgts());
    this.store.dispatch(new fromFeature.GetUserActivityLogs({ ...this.logparam }));
    // this.store.dispatch(new fromFeature.GetAppDownloads(this.ReadAppdownloadparam));
  }

  UI() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('body-landing');
    body.classList.remove('body-login');
    body.classList.remove('mobile-toggle');
    body.classList.remove('events');
  }

  FilterChange(e) {
    this.apiSettingData = [];
    this.apiList.map((a) => {
      if (a.RegionId === e.value) {
        this.apiSettingData.push(a)
      }
    })
  }

  GetDefaultDate() {
    const today = new Date();
    // 從今天時間回推12個月
    const thisMonth = today.getMonth() + 1;
    const preYear_Month = ((thisMonth - 11) > 0) ? (thisMonth - 11) : (12 + (thisMonth - 11));
    const preYear_Year = ((thisMonth - 11) > 0) ? today.getFullYear() : today.getFullYear() - 1;
    const preYear = new Date(preYear_Year, preYear_Month - 1);
    const startts = preYear.getTime() / 1000;
    const endts = new Date(today.getFullYear(), today.getMonth() + 1, 0).getTime() / 1000 + (24 * 60 * 60 - 1);
    this.logparam = {
      ...this.logparam,
      start_date: startts,
      end_date: endts,
    };
  }

  private prependTypeColumn(cols: any[] = []): any[] {
    if (!cols?.length) {
      return [{ ...this.typeColumn }];
    }
    if (cols[0]?.field === 'type') {
      return cols;
    }
    return [{ ...this.typeColumn }, ...cols];
  }

  ngOnDestroy() {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.unsubscribe();
  }
}
